// src/pages/Servicii.jsx
import React from "react";
import { motion } from "framer-motion";
import Title from "../components/ui/Title";
import SectionTitle from "../components/ui/SectionTitle";

export default function Servicii() {
  return (
    <motion.div
      className="p-6 max-w-4xl mx-auto space-y-8 text-text-body"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <Title>Servicii</Title>

      <div className="space-y-6">

        <section>
          <SectionTitle>Coaching cu Design</SectionTitle>
          <p>
            Sesiuni individuale în care aducem împreună harta ta Human Design, întrebările tale actuale și vocea ta autentică. Spațiu de reflecție, susținere și reîmputernicire blândă.
          </p>
        </section>

        <section>
          <SectionTitle>Workshopuri vii</SectionTitle>
          <p>
            Întâlniri de grup, online sau offline, pentru explorare aplicată: de la înțelegerea centrilor și tipurilor energetice, la integrarea în relații, muncă și alegeri zilnice.
          </p>
        </section>

        <section>
          <SectionTitle>Analize Human Design (Student Reading)</SectionTitle>
          <p>
            Ofer analize pentru cei care vor să își înceapă parcursul conștient în Design – în special pentru Studenți aflați în proces de formare sau pentru cei care doresc un start curat, viu și aplicabil.
          </p>
        </section>

        <div className="border-t pt-4 text-sm opacity-80">
          <p>
            Nu creez dependențe. Creez claritate. Și o chemare înapoi către tine.
          </p>
        </div>
      </div>
    </motion.div>
  );
}
